// extracted by mini-css-extract-plugin
export default {"moviesList":"ExploreList_moviesList__cVzww"};